<div>
  <table class='task'>
    <tbody>
    <tr>
      <!-- <td></td> -->
      <td class='question'>
        {{ question.text }}
      </td>
    </tr>
    <tr>
      <!-- <td class='number'>{{ questIndex + 1 }}.</td> -->
      <td class='answer'>
        <div class='input-group big active'>
          <span class='cross-icon' (click)='clearAnswer()'>
            <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
              <defs>
                <style>.task_question-close-cls-1,
                task_question-close-cls-2{fill:none;}
                .task_question-close-cls-2{stroke:#ccc;stroke-miterlimit:10;stroke-width:2px;}
                .cross-icon:hover .task_question-close-cls-2{stroke:#999999;
                  stroke-miterlimit:10;stroke-width:2px;}</style>
              </defs>
              <title></title>
              <g id='Слой_2' data-name='Слой 2'>
                <g id='Слой_10' data-name='Слой 10'>
                  <rect class='task_question-close-cls-1' width='24' height='24'/>
                  <line class='task_question-close-cls-2' x1='1.5' y1='1.5' x2='22.5' y2='22.5'/>
                  <line class='task_question-close-cls-2' x1='1.5' y1='22.5' x2='22.5' y2='1.5'/>
                </g>
              </g>
            </svg>
          </span>

          <input type='text' [(ngModel)]='answerString' class='text-left'>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
  <ng-container>
    <div class='keyboard'>
      <div class='keyboard-container'>
        <ul>
          <li class='keyboard-item' *ngFor='let button of buttons'>
            <a (click)='keyboardClicked(button)' appDisTouchmove>
              {{ button }}
            </a>
          </li>
          <li class='keyboard-item'>
            <a (click)='clickSpace()' appDisTouchmove>
              __
            </a>
          </li>
          <li class='keyboard-item enter'>
            <a (click)='checkAnswer()' appDisTouchmove></a>
          </li>
        </ul>
      </div>
    </div>
  </ng-container>
</div>
